import { LoadingButton } from '@mui/lab'
import { Checkbox, FormControlLabel, Typography, Button } from '@mui/material'
import { OverlayState } from '@/hooks/useOverlay'
import { Dialog, DialogContent, DialogFooter } from '@/components/dialog'

type CreateMatchConfirmDialogProps = {
  overlay: OverlayState
  doNotShowAgain: boolean
  isCreating: boolean
  onClose: () => void
  onDoNotShowAgainChange: (value: boolean) => void
  onConfirm: () => void
}

export default function CreateMatchConfirmDialog({
  overlay,
  doNotShowAgain,
  isCreating,
  onClose,
  onDoNotShowAgainChange,
  onConfirm,
}: CreateMatchConfirmDialogProps) {
  return (
    <Dialog
      {...overlay}
      title="Create Match"
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          Are you sure you want to create this line item match?
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={doNotShowAgain}
              onChange={(e) => onDoNotShowAgainChange(e.target.checked)}
            />
          }
          label="Do not show this again."
        />
      </DialogContent>
      <DialogFooter>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton loading={isCreating} onClick={onConfirm}>
          Create
        </LoadingButton>
      </DialogFooter>
    </Dialog>
  )
}
